export const GET_EVENT_PRICINGS = "GET_EVENT_PRICINGS";
export const GET_EVENT_PRICING_BY_ID = "GET_EVENT_PRICING_BY_ID";
export const UPDATE_EVENT_PRICING = "UPDATE_EVENT_PRICING";
export const DELETE_EVENT_PRICING = "DELETE_EVENT_PRICING";
export const CREATE_EVENT_PRICING = "CREATE_EVENT_PRICING";
